import { INK } from '@blorbs/common';

/**
 * Ink-outline helpers. Line widths are given in world units but never drop
 * below a couple of screen pixels, so the drawing stays "inked" when zoomed out.
 */
export function inkStroke(ctx: CanvasRenderingContext2D, worldWidth: number, scale: number, color = INK): void {
  ctx.strokeStyle = color;
  ctx.lineWidth = Math.max(worldWidth, 1.6 / scale);
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
}

export function circle(ctx: CanvasRenderingContext2D, x: number, y: number, r: number): void {
  ctx.beginPath();
  ctx.arc(x, y, r, 0, Math.PI * 2);
}

export function ellipse(ctx: CanvasRenderingContext2D, x: number, y: number, rx: number, ry: number, rot = 0): void {
  ctx.beginPath();
  ctx.ellipse(x, y, rx, ry, rot, 0, Math.PI * 2);
}

/** Deterministic pseudo-random in [0,1) from an integer seed. */
export function hash(n: number): number {
  let x = (n + 0x9e3779b9) | 0;
  x = Math.imul(x ^ (x >>> 16), 0x85ebca6b);
  x = Math.imul(x ^ (x >>> 13), 0xc2b2ae35);
  x ^= x >>> 16;
  return (x >>> 0) / 4294967296;
}
